import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Privacy() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <div className="container mx-auto px-4 py-8 max-w-4xl">
          <h1 className="text-3xl font-bold mb-8">Privacy Policy</h1>
          
          <div className="prose max-w-none">
            <p className="text-gray-600 mb-6">Last updated: January 2025</p>
            
            <div className="space-y-6">
              <section>
                <h2 className="text-2xl font-semibold mb-4">Information Collection</h2>
                <p className="mb-4">
                  We value your privacy. This website may collect the following types of information:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Website usage statistics (via Google Analytics)</li>
                  <li>Cookie information to improve user experience</li>
                  <li>Contact information you voluntarily provide</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">Information Usage</h2>
                <p className="mb-4">Collected information is used to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Provide and improve website services</li>
                  <li>Analyze website usage patterns</li>
                  <li>Display relevant advertising content</li>
                  <li>Respond to user inquiries</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">Third-Party Services</h2>
                <p className="mb-4">This website uses the following third-party services:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Google AdSense - for displaying advertisements</li>
                  <li>Google Analytics - for website analysis</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">Cookie Policy</h2>
                <p className="mb-4">
                  This website uses cookies to improve user experience. Continuing to use this website indicates your consent to our cookie policy.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
                <p>
                  If you have any questions about this Privacy Policy, please contact us at:
                  <br />
                  Email: aitoolshub2025@gmail.com
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}